if (!customElements.get("product-lightbox")) {
  customElements.define(
    "product-lightbox",
    class ProductLightbox extends HTMLElement {
      constructor() {
        super();
        this.isQuickView = this.closest("#quick-view");
      }

      connectedCallback() {
        if (this.isQuickView) return;
        const closeSVG = `<svg aria-hidden="true" focusable="false" width="16" height="16" class="icon icon-close pswp__icn" viewBox="0 0 24 24"><path d="m19.4935898 20c-.128 0-.256-.049-.354-.146l-7.646-7.647-7.64599998 7.647c-.196.195-.512.195-.708 0-.195-.196-.195-.512 0-.708l7.64699998-7.646-7.64699998-7.646c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l7.64599998 7.647 7.646-7.647c.196-.195.512-.195.708 0 .195.196.195.512 0 .708l-7.647 7.646 7.647 7.646c.195.196.195.512 0 .708-.098.097-.226.146-.354.146" fill="currentColor"></path></svg>`;

        this.productLightbox = new window.PhotoSwipeLightbox({
          gallery: this,
          children: "[data-lightbox-trigger]",
          showHideAnimationType: "fade",
          showAnimationDuration: 500,
          initialZoomLevel: "fit",
          secondaryZoomLevel: "fill",
          maxZoomLevel: 4,
          scaleMode: "zoom",
          bgOpacity: 1,
          counter: false,
          closeOnVerticalDrag: true,
          allowPanToNext: false,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          closeSVG: closeSVG,
          pswpModule: () => window.PhotoSwipe,
        });
        this.setupFilters();
        this.setupListeners();
        this.productLightbox.init();
      }

      setupListeners() {
        this.productLightbox.on("contentLoad", this.handleVideos.bind(this));

        this.productLightbox.on("uiRegister", this.addThumbnails.bind(this));

        this.productLightbox.on("openingAnimationStart", () => {
          document.body.classList.add("overflow-hidden");
          addScrollbarPadding();
        });

        this.productLightbox.on("closingAnimationEnd", () => {
          const mediaGallery = this.closest("media-gallery");
          if (mediaGallery) {
            const activeSlide = mediaGallery.querySelector("swiper-slide.swiper-slide-active");
            mediaGallery.playActiveMedia(activeSlide);
          }
          document.body.classList.remove("overflow-hidden");
          removeScrollbarPadding();
        });

        this.productLightbox.on("change", this.onSlideChange.bind(this));
      }

      setupFilters() {
        this.productLightbox.addFilter("itemData", (itemData, index) => {
          const videoUrl = itemData.element.dataset.videoUrl;
          if (videoUrl) {
            itemData.videoUrl = videoUrl;
            itemData.posterUrl = itemData.element.href;
          }
          return itemData;
        });
      }

      handleVideos(e) {
        const { content } = e;
        if (content.type === "video") {
          e.preventDefault();
          content.element = document.createElement("div");
          content.element.className = "pswp__video-container";
          const videoElement = document.createElement("video");
          videoElement.autoplay = true;
          videoElement.controls = false;
          videoElement.muted = true;
          videoElement.loop = true;
          videoElement.poster = content.data.posterUrl;
          const sourceElement = document.createElement("source");
          sourceElement.src = content.data.videoUrl;
          sourceElement.type = "video/mp4";
          videoElement.appendChild(sourceElement);
          content.element.appendChild(videoElement);
        }
      }

      onSlideChange(e) {
        window.pauseAllMedia();
        const videoElement = document.querySelector('.pswp__item[aria-hidden="false"] video');
        if (videoElement) {
          videoElement.play();
        }
      }

      addThumbnails() {
        this.productLightbox.pswp.ui.registerElement({
          name: "thubmnails",
          className: "pswp-thumbnails",
          appendTo: "wrapper",
          onInit: (element, pswp) => {
            const thumbnailEls = [];
            let previousIndex = -1;

            for (let i = 0; i < pswp.getNumItems(); i++) {
              const thumbnailEl = document.createElement("button");
              thumbnailEl.type = "button";
              thumbnailEl.className = "pswp-thumbnail";
              thumbnailEl.onclick = () => pswp.goTo(i);

              const imgEl = document.createElement("img");
              imgEl.className = "pswp-thumbnail__image";
              imgEl.src = document.querySelector(
                `[data-lightbox-trigger] img[data-index="${i + 1}"]`
              ).dataset?.thumbnail;

              thumbnailEl.appendChild(imgEl);

              if (
                document.querySelector(`[data-lightbox-trigger] img[data-index="${i + 1}"]`).closest("deferred-media")
              ) {
                thumbnailEl.classList.add("pswp-thumbnail--video");
                const svgEl = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svgEl.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                svgEl.setAttribute("viewBox", "0 0 24 24");
                svgEl.innerHTML =
                  '<path fill="currentColor" d="m10.0005 9.34308884v4.31499996l3.956-2.157zm-.5 5.65799996c-.088 0-.177-.024-.255-.07-.152-.09-.245-.254-.245-.43v-5.99999996c0-.177.093-.34.245-.43.151-.089.341-.093.494-.009l5.5 2.99999996c.161.087.261.256.261.439s-.1.351-.261.439l-5.5 3c-.074.04-.157.061-.239.061zm2-10.99999996c-6.729 0-7.5.771-7.5 7.49999996 0 6.729.771 7.5 7.5 7.5s7.5-.771 7.5-7.5c0-6.72899996-.771-7.49999996-7.5-7.49999996zm0 15.99999996c-7.309 0-8.5-1.192-8.5-8.5 0-7.30899996 1.191-8.49999996 8.5-8.49999996s8.5 1.191 8.5 8.49999996c0 7.308-1.191 8.5-8.5 8.5z"></path>';
                thumbnailEl.appendChild(svgEl);
              }

              element.appendChild(thumbnailEl);
              thumbnailEls.push(thumbnailEl);
            }

            pswp.on("change", () => {
              if (previousIndex >= 0) {
                thumbnailEls[previousIndex].removeAttribute("aria-current");
              }
              thumbnailEls[pswp.currIndex].setAttribute("aria-current", "true");
              previousIndex = pswp.currIndex;
            });
          },
        });
      }
    }
  );
}
